import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "../classes/constants/routeConstants";
import LoadingOverlay from "../components/loadingBar/LoadingOverlay";
import { useAuth } from "../hooks/useAuth";

const PrivateRoute = ({ children, requiredPermissions = [] }) => {
  const {
    isAuthenticated,
    loading,
    checkPermissions,
    login,
    postLogout,
    user,
  } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      // Trigger OIDC login redirect
      login();
    }
  }, [loading, isAuthenticated, login]);

  useEffect(() => {
    if (!loading && user?.expired) {
      postLogout();
    }
  }, [loading, user, postLogout]);

  if (
    loading ||
    (!isAuthenticated && !window.location.href.includes("/callback"))
  ) {
    return <LoadingOverlay />;
  }

  if (isAuthenticated && !checkPermissions(requiredPermissions)) {
    return (
      <Navigate to={ROUTES.NO_PERMISSION} state={{ from: location }} replace />
    );
  }

  return children;
};

export default PrivateRoute;
